import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function UserCircleSolidIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.40917 17.6473C6.43291 15.8558 8.33814 14.7501 10.4016 14.7501H13.5983C15.6618 14.7501 17.567 15.8558 18.5907 17.6473L18.5936 17.6523L19.3725 19.0398C19.5437 19.3447 19.4815 19.7274 19.2226 19.9623C17.3147 21.6939 14.7798 22.75 12 22.75C9.22021 22.75 6.68531 21.6939 4.77744 19.9623C4.51856 19.7274 4.45636 19.3447 4.62748 19.0399L5.40917 17.6473Z"
				fill="currentColor"
			/>
			<path
				d="M8.5 10C8.5 8.067 10.067 6.5 12 6.5C13.933 6.5 15.5 8.067 15.5 10C15.5 11.933 13.933 13.5 12 13.5C10.067 13.5 8.5 11.933 8.5 10Z"
				fill="currentColor"
			/>
		</svg>
	);
}

UserCircleSolidIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default UserCircleSolidIcon;
